import React, { useState, useEffect } from 'react'
import { Input } from '@material-ui/core'
import { useDebouncedValue, useDidUpdateEffect } from '../utils'

export default function DebounceInput(props) {
  const { handleFilterChanged, filter, column } = props
  const [realtimeValue, setRealtimeValue] = useState(filter?.value || '')
  const debouncedValue = useDebouncedValue(realtimeValue)
  
  useDidUpdateEffect(() => {
    handleFilterChanged({
      columnName: column?.name,
      value: debouncedValue || null
    })
  }, [debouncedValue])
  
  const handleChange = ({ target: { value } }) => setRealtimeValue(value)
  
  return (
    <Input
      {...props}
      placeholder="Filter..."
      value={realtimeValue}
      onChange={handleChange}
    />
  )
}